import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IntegrationService } from '../../../shared/services/integration.service';

@Component({
    selector: 'view-edit',
    template: '<img href="" class="view-edit"  (click)="openViewInstruction($event)" [src]="editIcon"/>',
    styles: ['.view-edit { color: #006E99;letter-spacing: 0.08px;font-family: Arial;} .view-edit:hover {cursor: pointer;}']
})
export class ViewEditRendererComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;
  public editIcon: string;

  constructor(private integrationService: IntegrationService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.editIcon = this.integrationService.getApplicationPath() + 'assets/images/Icon_Edit_Active_default.svg';
  }

  public openViewInstruction(event): void {
    event.preventDefault();
    const cloneData = structuredClone(this.params.data);
    this.params.context.openViewEditInstruction(cloneData);
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
